export default __webpack_public_path__ + "51cc964859dfa50c7a291fd5ae390cb6.webp";